import React from 'react';
import { Box } from '@mui/material';
import { theme } from '../../theme/colors';
import { POLICY_NAV_LABEL } from '../../constants/policyLabels';

export const POLICY_VIEW_LEGISLATION = 'legislation';
export const POLICY_VIEW_BALLOT = 'ballot';

const TABS = [
  { id: POLICY_VIEW_LEGISLATION, label: 'Legislation' },
  { id: POLICY_VIEW_BALLOT, label: 'Ballot Measures' },
];

export default function PolicyViewTabs({ activeView, onViewChange }) {
  return (
    <Box
      role="tablist"
      aria-label={`${POLICY_NAV_LABEL} content type`}
      sx={{
        display: 'flex',
        gap: 0,
        borderBottom: '1px solid #e5e7eb',
        px: { xs: 1.5, sm: 2 },
      }}
    >
      {TABS.map((tab) => {
        const isActive = activeView === tab.id;
        return (
          <Box
            key={tab.id}
            component="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onViewChange(tab.id)}
            sx={{
              minHeight: 44,
              px: 2.5,
              py: 1.25,
              border: 'none',
              borderBottom: isActive ? `2px solid ${theme.primary}` : '2px solid transparent',
              mb: '-1px',
              bgcolor: 'transparent',
              color: isActive ? theme.primary : '#64748b',
              fontWeight: 700,
              fontSize: 14,
              cursor: 'pointer',
              fontFamily: 'inherit',
              transition: 'color 0.15s',
              '&:hover': { color: theme.primary },
            }}
          >
            {tab.label}
          </Box>
        );
      })}
    </Box>
  );
}
